import {apiCall} from 'state/actions/api'

const GOT_WILLDOC_URL = 'app/willdoc/GOT_WILLDOC_URL'

export default (state = false, action) => {
	if (action.type === GOT_WILLDOC_URL) {
		return action.location
	}
	return state
}

export const getWillDocUrl = () => (dispatch, getState) => {
	if (!getState().app.willDocUrl) {
		return dispatch(apiCall('/data/wildoc'))
		.then(({location}) => dispatch({
			type: GOT_WILLDOC_URL,
			location,
		}))
	}
}



// WEBPACK FOOTER //
// ./components/willdoc/wil-duck.js